import { ChartMetricData } from "@api/common";
import { Country, lookupRegionInfo } from "@store";
import * as React from "react";
import { MapView } from "./MapView";

export interface RegionMapChartProps extends React.SVGProps<SVGSVGElement> {
    binColors: string[];
    region: ChartMetricData;
    countries: Country[];
    geographicSvg: string;
}

export function RegionMapChart(props: RegionMapChartProps) {
    const { region, countries, geographicSvg, binColors } = props;

    const data = region.data
        .map(d => ({
            regionCode: d["dimension-values"][0],
            metric: region.metric,
            ...region.bins.find(b => b.index === d["metric-value"])
        }))
        .filter(d => !!d.regionCode);

    const regionCode = data[0].regionCode;

    const regionInfo = lookupRegionInfo(countries, regionCode);

    if (!regionInfo) {
        return <span>{`No country info for ${regionCode} region`}</span>;
    }

    const mapViewData = data.reduce((result, item: any) => {
        result[item.regionCode] = {
            value: `${item.min}-${item.max}`,
            color: binColors[item.index],
            bin: item.index
        };

        return result;
    }, {});

    return <MapView countryAlpha3Code={geographicSvg} regions={mapViewData} />;
}
